// extracted by mini-css-extract-plugin
module.exports = {"iconImg":"index_iconImg__3SepI"};